import React from "react";
import { FormattedMessage as FM } from "react-intl";

import ColForm from "components/MeForm/ColForm";
import { classNames } from "tools/ui";

function FormField(props) {
  let styleTheme = "text-neutral-700 font-bold";
  if (props.dark) {
    styleTheme = "text-white font-light";
  }

  return (
    <ColForm colspan={props.colspan}>
      {props.label && (
        <label
          className={classNames(
            "flex text-base mt-3 mb-2 ml-1 max-h-5",
            styleTheme,
          )}
          htmlFor={props.name}
        >
          <FM id={props.label} key={props.label} />
          {props.required && (
            <p className="font-bold text-base text-red-500">&nbsp; *</p>
          )}
        </label>
      )}
      {props.children}
    </ColForm>
  );
}

export default FormField;
